/**
 * Zeitleiste der Version 9 „Deine Woche“. Jede Station gehört zu einem
 * Wochentag. Die ids der Produkt-Stationen sind dieselben wie in
 * v3/beats.js, so laufen die Panels aus v3 über `BeatsProvider` mit.
 * `len` ist die Länge in vh.
 */

const RAW = [
  { id: 'intro', day: 'mo', len: 70 },
  { id: 'hr', day: 'mo', len: 170 },
  { id: 'analyse', day: 'mo', len: 190 },
  { id: 'profil', day: 'mo', len: 170 },
  { id: 'link', day: 'di', len: 170 },
  { id: 'games', day: 'di', len: 190 },
  { id: 'talente', day: 'di', len: 150 },
  { id: 'liste', day: 'mi', len: 170 },
  { id: 'magic', day: 'mi', len: 170 },
  { id: 'regeln', day: 'mi', len: 150 },
  { id: 'report', day: 'mi', len: 210 },
  { id: 'gespraech', day: 'do', len: 170 },
  { id: 'team', day: 'do', len: 190 },
  { id: 'kreuz', day: 'do', len: 170 },
  { id: 'absagen', day: 'fr', len: 170 },
  { id: 'ats', day: 'fr', len: 150 },
  { id: 'support', day: 'fr', len: 120 },
  { id: 'finale', day: 'fr', len: 160 }
]

export const DAYS = [
  { id: 'mo', label: 'Montag', short: 'Mo', topic: 'Stelle definieren' },
  { id: 'di', label: 'Dienstag', short: 'Di', topic: 'Talente gewinnen' },
  { id: 'mi', label: 'Mittwoch', short: 'Mi', topic: 'Vorauswahl' },
  { id: 'do', label: 'Donnerstag', short: 'Do', topic: 'Gespräche' },
  { id: 'fr', label: 'Freitag', short: 'Fr', topic: 'Abschluss' }
]

export const TOTAL_VH = RAW.reduce((sum, b) => sum + b.len, 0)

export const BEATS = RAW.reduce((list, b) => {
  const start = list.length ? list[list.length - 1].at[1] : 0
  list.push({ ...b, at: [start, start + b.len / TOTAL_VH] })
  return list
}, [])

const B = Object.fromEntries(BEATS.map((b) => [b.id, b.at]))

export const inB = (beat, a, b) => {
  const [s, e] = B[beat]
  const len = e - s
  return [s + a * len, s + b * len]
}

export const atB = (beat, a) => inB(beat, a, a)[0]
